import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getQuickFilterWidgetStyles = showWithCard => {
  return StyleSheet.create({
    root: Object.assign({
      flexDirection: showWithCard ? 'column' : 'row'
    }, !showWithCard && {
      alignItems: 'center'
    }),
    header: Object.assign(Object.assign({
      flexShrink: 0
    }, !showWithCard && {
      marginRight: tokens.spacing.SPACING_12
    }), showWithCard && {
      marginBottom: tokens.spacing.SPACING_12
    }),
    filterListContainer: Object.assign({
      flexGrow: 0
    }, showWithCard && {
      flexDirection: 'row',
      flexWrap: 'wrap',
      marginBottom: -tokens.spacing.SPACING_12
    }),
    itemRightSpace: {
      marginRight: tokens.spacing.SPACING_12
    },
    itemBottomSpace: Object.assign({}, showWithCard && {
      marginBottom: tokens.spacing.SPACING_12
    })
  });
};